import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";

// ----------------------------------------------------------------------

export function FormThankYouPage() {
  const { leadId } = useParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(20);
  const [redirectUrl, setRedirectUrl] = useState("https://sensationsolutions.com/");

  // Determine redirect URL based on hostname
  useEffect(() => {
    const hostname = window.location.hostname.toLowerCase();

    if (hostname.includes("pcte")) {
      setRedirectUrl("https://pcte.edu.in/");
    } else {
      setRedirectUrl("https://sensationsolutions.com/");
    }
  }, []);

  // Automatic redirect timer
  useEffect(() => {
    if (countdown === 0) {
      window.location.href = redirectUrl;
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, redirectUrl]);

  // Set document title
  useEffect(() => {
    document.title = "Thank You | Form Submitted";
  }, []);

  const handleBackToHome = () => {
    // Navigate to the determined home page
    window.location.href = redirectUrl;
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 40%, #f0f9ff 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
        padding: "24px",
      }}
    >
      {/* Card */}
      <div
        style={{
          background: "white",
          borderRadius: "20px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.10), 0 4px 16px rgba(0,0,0,0.06)",
          padding: "52px 48px",
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
          animation: "fadeInUp 0.5s ease",
        }}
      >
        {/* Animated success icon */}
        <div
          style={{
            width: "88px",
            height: "88px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #d1fae5, #a7f3d0)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 28px",
            animation: "popIn 0.5s cubic-bezier(0.34,1.56,0.64,1)",
          }}
        >
          <svg
            width="44"
            height="44"
            fill="none"
            stroke="#059669"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* Heading */}
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "800",
            color: "#111827",
            marginBottom: "12px",
            letterSpacing: "-0.5px",
          }}
        >
          Thank You!
        </h1>

        {/* Subtext */}
        <p
          style={{
            fontSize: "16px",
            color: "#6b7280",
            lineHeight: "1.7",
            marginBottom: "8px",
          }}
        >
          Your form has been submitted successfully. We&apos;ve received your information and will get back to you shortly.
        </p>

        {/* Countdown redirect message */}
        <p
          style={{
            fontSize: "14px",
            color: "#9ca3af",
            marginBottom: "24px",
            fontStyle: "italic",
          }}
        >
          Redirecting in <span style={{ color: "#059669", fontWeight: "600" }}>{countdown}</span> seconds...
        </p>
        {/* Divider */}
        <div
          style={{
            height: "1px",
            background: "linear-gradient(90deg, transparent, #e5e7eb, transparent)",
            marginBottom: "28px",
          }}
        />

        {/* Back to Home button */}
        <button
          onClick={handleBackToHome}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "linear-gradient(135deg, #059669, #047857)",
            color: "white",
            border: "none",
            borderRadius: "12px",
            padding: "14px 36px",
            fontSize: "15px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s ease",
            boxShadow: "0 4px 14px rgba(5,150,105,0.35)",
            letterSpacing: "0.2px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(5,150,105,0.45)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 4px 14px rgba(5,150,105,0.35)";
          }}
        >
          <svg
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          Back to Home
        </button>
      </div>

      {/* Keyframe animations injected inline */}
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes popIn {
          from { opacity: 0; transform: scale(0.5); }
          to   { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

export default FormThankYouPage;
